module.exports = __webpack_public_path__ + "img/thumbnail-header-19.54ae7b2.png";